import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_BASE_URL}/surveys`,
  headers: {
    'Content-Type': 'application/json'
  }
});

/**
 * Fetch all active survey questions ordered by sort_order
 */
export const getSurveyQuestions = async () => {
  try {
    const response = await api.get('/questions');
    return response.data;
  } catch (error) {
    console.error('Error fetching survey questions:', error);
    throw error;
  }
};

/**
 * Track survey interactions (entry, completion)
 */
export const trackSurveyEvent = async (anonymousId, userId = null, eventType = 'entry') => {
  try {
    const response = await api.post('/track', {
      anonymous_id: anonymousId,
      user_id: userId,
      event_type: eventType
    });
    return response.data;
  } catch (error) {
    console.error('Error tracking survey event:', error);
    // Non-blocking error logging
    return null;
  }
};

/**
 * Submit completed survey answers
 * answers: Array of { question_id, text, answer_type }
 */
export const submitSurvey = async (anonymousId, answers) => {
  try {
    const response = await api.post('/submit', {
      anonymous_id: anonymousId,
      answers: answers
    });
    return response.data;
  } catch (error) {
    console.error('Error submitting survey:', error);
    throw error;
  }
};

export default api;
